export default "__VITE_ASSET__CqPTrghB__"